<template>
  <div class="flex min-h-screen font-inter">
    <div class="flex-grow">
        <main class="w-full px">
            <TalentProfile />
        </main>
    </div>
    </div>
  </template>
  
  <script>
  import TalentProfile from '@/components/profiles/TalentProfile.vue';
  
  export default {
    name: 'ProfileView',
    components: {
      TalentProfile,
    },
    mounted() {
      window.scrollTo(0, 0);
    },
  };
  </script>
  
  <style scoped>
  </style>
  